export const ko = {
  name: "Korean",
  flagCode: "kr",
  locale: "ko-KR",
  project: { name: "운전자 등록" },
  key: "ko",
  validations: {
    PLEASE_SELECT_CITY: "도시를 선택해주세요.",
    PLEASE_SELECT_SERVICE: "서비스를 선택해주세요.",
    PLEASE_SELECT_DRIVER_TYPE: "기사 유형을 선택해주세요.",
    PLEASE_INPUT_FIRSTNAME: "이름을 입력해주세요.",
    PLEASE_INPUT_LASTNAME: "성을 입력해주세요.",
    PLEASE_INPUT_EMAIL: "이메일을 입력해주세요.",
    INVALID_EMAIL: "유효한 이메일을 입력해주세요.",
    PLEASE_INPUT_MOBILE_PHONE: "전화번호를 입력해주세요.",
    INVALID_PHONE_NUMBER: "유효한 전화번호를 입력해주세요.",
    PHONE_NUNBER_EXITS: "이미 다른 계정에서 사용 중인 전화번호입니다.",
    USERNAME_EXITS: "이미 사용 중인 사용자 이름입니다.",
    ERROR_INPUT_VALID_USERNAME:
      "사용자 이름은 소문자와 숫자만 사용할 수 있으며, 3자 이상 20자 이하이어야 합니다.",
    FIELD_IS_REQUIRED: "이 필드는 필수 입력 항목입니다.",
    REFERRAL_CODE_INVALID: "추천인 번호 유효하지 않습니다.",
    EMAIL_EXITS: "이미 존재하는 이메일입니다. 다른 이메일을 입력해주세요.",
    INVALID_USERNAME: "유효한 사용자 이름을 입력해주세요.",
    FIELD_IS_REQUIRED_BETWEEN_3_TO_20:
      "사용자 이름은 3자 이상 20자 이하이어야 합니다.",
    PHONE_NUNBER_EXITS_IN_GROUP: "",
  },
  errors: {
    3034: "이미 시스템에 등록된 전화번호입니다. 다른 번호를 입력해주세요.",
    4001: "이미 시스템에 등록된 차량 번호판입니다.",
    NETWORK_ERROR: "오류: 네트워크 오류",
  },
  general: {
    CONTINUE: "계속",
    STEP_COMPLETE: "{0}/{1} 완료",
    STEP_HEADER: "{0}단계",
    BACK: "뒤로",
    NEXT: "다음",
    SUBMIT: "제출",
    Clear_Selected_Items: "선택한 항목 지우기",
    no_results: "결과 없음",
    add_new_item: "새로 추가",
  },
  home: {
    BECOME: "%{name} 드라이버가 되세요.",
    HEADING: "시작하려면 기본 정보를 입력하세요.",
    APPLY_NOW: "가입",
    INDIVIDUAL_CAR_GOJO: "운송/택시 – 차량 소유",
    INDIVIDUAL_CAR: "운송 – 내 차량 보유",
    COMPANY_CAR: "운송 – 회사 차량",
    DELIVERY_INDIVIDUAL_CAR: "배송 – 차량 소유",
    DELIVERY_COMPANY_CAR: "배송 – 회사 차량",
    PLACEHOVER_SELECT_PRE_CITY: "작전 지역",
    PLACEHOVER_SELECT_REGISTRATION_TYPE: "운전자 유형 선택",
    USERNAME: "사용자 이름",
    FIRST_NAME: "이름",
    LAST_NAME: "성",
    EMAIL: "이메일 (선택 사항)",
    PHONE_NUMBER: "휴대폰 번호",
    REFERRAL_CODE: "추천인 번호 (선택 입력)",
    I_AGREE_TO: "가입함으로써 다음 내용을 읽고 동의합니다",
    TERMS_OF_USE: "서비스 이용 약관",
    AND: "그리고",
    PRIVACY_POLICY: "개인정보 처리방침",
    I_AGREE_TO_AFTER: ".",
    Company: "공급자",
  },
  finish: {
    FINISH_1: "%{name}에 가입해 주셔서 감사합니다!",
    FINISH_3: "지금 로그인하고 시작하세요!",
    FINISH_USE_PASSWORD_1: "거의 다 왔습니다!",
    FINISH_USE_PASSWORD_2:
      "계정을 활성화하고 작업을 받으려면 다음 단계를 따라주세요:",
    FINISH_USE_PASSWORD_3: "1. 등록한 휴대폰 번호로 로그인하세요",
    FINISH_USE_PASSWORD_4:
      "2. 비밀번호: <span style='font-weight: bold'>12345678</span>",
    FINISH_USE_PASSWORD_5: "3. 신청을 완료하세요",
    OK: "로그인",
    downloadApp:
      "지금 <span style='color: %{color}' >%{name}</span> 드라이버 앱을 다운로드하고 등록한 휴대폰 번호로 로그인하세요.",
  },
  datePlaceHolder: "MM/DD/YYYY",
};
